import apiClient from '@/services/axios'

export async function put(venueSetup) {

  var response = await apiClient.put(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/venue-setups/' + venueSetup.id, venueSetup);

  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to post venue setup.')
}
